import * as Icons from '../../Icons/index';
import { Environment, Node } from '../types/global';
import * as Material from './materials';

export const voidTile: Environment = {
    type: 'Backgound',
    name: 'Void',
    symbol: Icons.voidTile
};

export const basicWalls: Environment =
{
    type: 'Wall',
    name: 'Wall',
    symbol: Icons.wallImg
};

const cavesF1: Environment = {
    type: 'Background',
    name: 'Caves floor',
    symbol: Icons.cFloor1
};
const cavesF2: Environment = {
    type: 'Background',
    name: 'Caves floor',
    symbol: Icons.cFloor2
};
const cavesF3: Environment = {
    type: 'Background',
    name: 'Caves floor',
    symbol: Icons.cFloor3
};
const cavesF4: Environment = {
    type: 'Background',
    name: 'Caves floor',
    symbol: Icons.cFloor4
};
const cavesF5: Environment = {
    type: 'Background',
    name: 'Caves floor',
    symbol: Icons.cFloor5
};
const cavesF6: Environment = {
    type: 'Background',
    name: 'Caves floor',
    symbol: Icons.cFloor6
};
const cavesF7: Environment = {
    type: 'Background',
    name: 'Caves floor',
    symbol: Icons.cFloor7
};
const cavesF8: Environment = {
    type: 'Background',
    name: 'Caves floor',
    symbol: Icons.cFloor8
};
const cavesF9: Environment = {
    type: 'Background',
    name: 'Caves floor',
    symbol: Icons.cFloor9
};

export const cFloorTiles: Environment[] = [
    cavesF1, cavesF2, cavesF3, cavesF4, cavesF5,
    cavesF6, cavesF7, cavesF8, cavesF9
]

const dungeonF1: Environment = {
    type: 'Background',
    name: 'Dungeon floor',
    symbol: Icons.dFloor1
};
const dungeonF2: Environment = {
    type: 'Background',
    name: 'Dungeon floor',
    symbol: Icons.dFloor2
};
const dungeonF3: Environment = {
    type: 'Background',
    name: 'Dungeon floor',
    symbol: Icons.dFloor3
};
const dungeonF4: Environment = {
    type: 'Background',
    name: 'Dungeon floor',
    symbol: Icons.dFloor4
};
const dungeonF5: Environment = {
    type: 'Background',
    name: 'Dungeon floor',
    symbol: Icons.dFloor5
};
const dungeonF6: Environment = {
    type: 'Background',
    name: 'Dungeon floor',
    symbol: Icons.dFloor6
};
const dungeonF7: Environment = {
    type: 'Background',
    name: 'Dungeon floor',
    symbol: Icons.dFloor7
};
const dungeonF8: Environment = {
    type: 'Background',
    name: 'Dungeon floor',
    symbol: Icons.dFloor8
};
const dungeonF9: Environment = {
    type: 'Background',
    name: 'Dungeon floor',
    symbol: Icons.dFloor9
};
const dungeonF10: Environment = {
    type: 'Background',
    name: 'Dungeon floor',
    symbol: Icons.dFloor10
};
const dungeonF11: Environment = {
    type: 'Background',
    name: 'Dungeon floor',
    symbol: Icons.dFloor11
};
const dungeonF12: Environment = {
    type: 'Background',
    name: 'Dungeon floor',
    symbol: Icons.dFloor12
}
const dungeonF13: Environment = {
    type: 'Background',
    name: 'Dungeon floor',
    symbol: Icons.dFloor13
};
const dungeonF14: Environment = {
    type: 'Background',
    name: 'Dungeon floor',
    symbol: Icons.dFloor14
};
const dungeonF15: Environment = {
    type: 'Background',
    name: 'Dungeon floor',
    symbol: Icons.dFloor15
};
const dungeonF16: Environment = {
    type: 'Background',
    name: 'Dungeon floor',
    symbol: Icons.dFloor16
};

export const dFloorTiles: Environment[] = [
    dungeonF1, dungeonF2, dungeonF3, dungeonF4, dungeonF5, dungeonF6, dungeonF7, dungeonF8,
    dungeonF9, dungeonF10, dungeonF11, dungeonF12, dungeonF13, dungeonF14, dungeonF15, dungeonF16
]

const forestF1: Environment = {
    type: 'Background',
    name: 'Forest floor',
    symbol: Icons.fFloor1
};
const forestF2: Environment = {
    type: 'Background',
    name: 'Forest floor',
    symbol: Icons.fFloor2
};
const forestF3: Environment = {
    type: 'Background',
    name: 'Forest floor',
    symbol: Icons.fFloor3
};
const forestF4: Environment = {
    type: 'Background',
    name: 'Forest floor',
    symbol: Icons.fFloor4
};
const forestF5: Environment = {
    type: 'Background',
    name: 'Forest floor',
    symbol: Icons.fFloor5
};
const forestF6:Environment = {
    type: 'Background',
    name: 'Forest floor',
    symbol: Icons.fFloor6
};
const forestF7: Environment = {
    type: 'Background',
    name: 'Forest floor',
    symbol: Icons.fFloor7
};
const forestF8: Environment = {
    type: 'Background',
    name: 'Forest floor',
    symbol: Icons.fFloor8
};
const forestF9: Environment = {
    type: 'Background',
    name: 'Forest floor',
    symbol: Icons.fFloor9
};
const forestF10: Environment = {
    type: 'Background',
    name: 'Forest floor',
    symbol: Icons.fFloor10
};
const forestF11: Environment = {
    type: 'Background',
    name: 'Forest floor',
    symbol: Icons.fFloor11
};
const forestF12: Environment = {
    type: 'Background',
    name: 'Forest floor',
    symbol: Icons.fFloor12
};
const forestF13: Environment = {
    type: 'Background',
    name: 'Forest floor',
    symbol: Icons.fFloor13
};
const forestF14: Environment = {
    type: 'Background',
    name: 'Forest floor',
    symbol: Icons.fFloor14
};
const forestF15: Environment = {
    type: 'Background',
    name: 'Forest floor',
    symbol: Icons.fFloor15
};
const forestF16:Environment = {
    type: 'Background',
    name: 'Forest floor',
    symbol: Icons.fFloor16
};

export const fFloorTiles: Environment[] = [
    forestF1, forestF2, forestF3, forestF4, forestF5, forestF6, forestF7, forestF8,
    forestF9, forestF10, forestF11, forestF12, forestF13, forestF14, forestF15, forestF16
];

const sandForestF1: Environment = {
    type: 'Background',
    name: 'Sand forest border floor',
    symbol: Icons.sfBorder1
};
const sandForestF2: Environment = {
    type: 'Background',
    name: 'Sand forest border floor',
    symbol: Icons.sfBorder2
};
const sandForestF3: Environment = {
    type: 'Background',
    name: 'Sand forest border floor',
    symbol: Icons.sfBorder3
};
const sandForestF4: Environment = {
    type: 'Background',
    name: 'Sand forest border floor',
    symbol: Icons.sfBorder4
};
const sandForestF5: Environment = {
    type: 'Background',
    name: 'Sand forest border floor',
    symbol: Icons.sfBorder5
};
const sandForestF6: Environment = {
    type: 'Background',
    name: 'Sand forest border floor',
    symbol: Icons.sfBorder6
};
const sandForestF7: Environment = {
    type: 'Background',
    name: 'Sand forest border floor',
    symbol: Icons.sfBorder7
};

export const sfFloorTiles: Environment[] = [
    sandForestF1, sandForestF2, sandForestF3, sandForestF4, sandForestF5, sandForestF6, sandForestF7
];

const sandF1: Environment = {
    type: 'Background',
    name: 'Sand floor',
    symbol: Icons.sFloor1
};
const sandF2: Environment = {
    type: 'Background',
    name: 'Sand floor',
    symbol: Icons.sFloor2
};
const sandF3: Environment = {
    type: 'Background',
    name: 'Sand floor',
    symbol: Icons.sFloor3
};
const sandF4: Environment = {
    type: 'Background',
    name: 'Sand floor',
    symbol: Icons.sFloor4
};
const sandF5: Environment = {
    type: 'Background',
    name: 'Sand floor',
    symbol: Icons.sFloor5
};
const sandF6: Environment = {
    type: 'Background',
    name: 'Sand floor',
    symbol: Icons.sFloor6
};

export const sFloorTiles: Environment[] = [
    sandF1, sandF2, sandF3, sandF4, sandF5, sandF6
];

const waterF1: Environment = {
    type: 'Wall',
    style: 'Water',
    name: 'Water 1',
    symbol: Icons.wFloor1
};
const waterF2: Environment = {
    type: 'Wall',
    style: 'Water',
    name: 'Water 2',
    symbol: Icons.wFloor2
};
const waterF3: Environment = {
    type: 'Wall',
    style: 'Water',
    name: 'Water 3',
    symbol: Icons.wFloor3
};
const waterF4: Environment = {
    type: 'Wall',
    style: 'Water',
    name: 'Water 4',
    symbol: Icons.wFloor4
};
const waterF5: Environment = {
    type: 'Wall',
    style: 'Water',
    name: 'Water 5',
    symbol: Icons.wFloor5
};
const waterF6: Environment = {
    type: 'Wall',
    style: 'Water',
    name: 'Water 6',
    symbol: Icons.wFloor6
};

export const wFloorTiles: Environment[] = [
    waterF1, waterF2, waterF3, waterF4, waterF5, waterF6
];

const beachShoreF1: Environment = {
    type: 'Background',
    name: 'Beach shore floor',
    symbol: Icons.bsFloor1
};
const beachShoreF2: Environment = {
    type: 'Background',
    name: 'Beach shore floor',
    symbol: Icons.bsFloor2
};
const beachShoreF3: Environment = {
    type: 'Background',
    name: 'Beach shore floor',
    symbol: Icons.bsFloor3
};
const beachShoreF4: Environment = {
    type: 'Background',
    name: 'Beach shore floor',
    symbol: Icons.bsFloor4
};
const beachShoreF5: Environment = {
    type: 'Background',
    name: 'Beach shore floor',
    symbol: Icons.bsFloor5
};
const beachShoreF6: Environment = {
    type: 'Background',
    name: 'Beach shore floor',
    symbol: Icons.bsFloor6
};

export const bsFloorTiles: Environment[] = [
    beachShoreF1, beachShoreF2, beachShoreF3, beachShoreF4, beachShoreF5, beachShoreF6
];

const beachMidShoreF1: Environment = {
    type: 'Wall',
    style: 'Water shore',
    name: 'Water shore 1',
    symbol: Icons.bmsFloor1
};
const beachMidShoreF2: Environment = {
    type: 'Wall',
    style: 'Water shore',
    name: 'Water shore 2',
    symbol: Icons.bmsFloor2
};
const beachMidShoreF3: Environment = {
    type: 'Wall',
    style: 'Water shore',
    name: 'Water shore 3',
    symbol: Icons.bmsFloor3
};
const beachMidShoreF4: Environment = {
    type: 'Wall',
    style: 'Water shore',
    name: 'Water shore 4',
    symbol: Icons.bmsFloor4
};
const beachMidShoreF5: Environment = {
    type: 'Wall',
    style: 'Water shore',
    name: 'Water shore 5',
    symbol: Icons.bmsFloor5
};
const beachMidShoreF6: Environment = {
    type: 'Wall',
    style: 'Water shore',
    name: 'Water shore 6',
    symbol: Icons.bmsFloor6
};

export const bmsFloorTiles: Environment[] = [
    beachMidShoreF1, beachMidShoreF2, beachMidShoreF3, beachMidShoreF4, beachMidShoreF5, beachMidShoreF6
];

const torchedWall: Environment =
{
    type: 'Wall',
    name: 'Torched Wall',
    symbol: Icons.torchdWallImg
};

const dungeonTp: Environment =
{
    type: 'Teleporter',
    name: 'dungeonTp',
    symbol: Icons.dungeonTp,
};

const dDoor1_left: Environment =
{
    type: 'Teleporter',
    name: 'dDoor1_left',
    symbol: Icons.dDoor1_left
};

const dDoor1_right: Environment =
{
    type: 'Teleporter',
    name: 'dDoor1_right',
    symbol: Icons.dDoor1_right
};

const dDoor2_left: Environment =
{
    type: 'Teleporter',
    name: 'dDoor2_left',
    symbol: Icons.dDoor2_left
};

const dDoor2_right: Environment =
{
    type: 'Teleporter',
    name: 'dDoor2_right',
    symbol: Icons.dDoor2_right
};

export const allDoors: Environment[] = [
    dDoor1_left, dDoor1_right, dDoor2_left, dDoor2_right
];

const brokenD1: Environment =
{
    type: 'Wall',
    name: 'brokenDDoor_1',
    symbol: Icons.brokenDD1
};

const brokenD2: Environment =
{
    type: 'Wall',
    name: 'brokenDDoor_2',
    symbol: Icons.brokenDD2
};

const brokenD3: Environment =
{
    type: 'Wall',
    name: 'brokenDDoor_3',
    symbol: Icons.brokenDD3
};

const brokenD4: Environment =
{
    type: 'Wall',
    name: 'brokenDDoor_4',
    symbol: Icons.brokenDD4
};

const brokenD5: Environment =
{
    type: 'Wall',
    name: 'brokenDDoor_5',
    symbol: Icons.brokenDD5
};

const brokenD6: Environment =
{
    type: 'Wall',
    name: 'brokenDDoor_6',
    symbol: Icons.brokenDD6
};

const brokenD7: Environment =
{
    type: 'Wall',
    name: 'brokenDDoor_7',
    symbol: Icons.brokenDD7
};

export const allBDoors: Environment[] = [
    brokenD1, brokenD2, brokenD3, brokenD4, brokenD5, brokenD6, brokenD7
];

export const transparentWall: Environment =
{
    type: 'Teleporter',
    name: 'transparentWall',
    symbol: Icons.transparentWall
};

const rockyWall1: Environment =
{
    type: 'Wall',
    style: 'Caves',
    name: 'Rocky Wall 1',
    symbol: Icons.rockyWall1
};
const rockyWall2: Environment =
{
    type: 'Wall',
    style: 'Caves',
    name: 'Rocky Wall 2',
    symbol: Icons.rockyWall2
};
const rockyWall3: Environment =
{
    type: 'Wall',
    style: 'Caves',
    name: 'Rocky Wall 3',
    symbol: Icons.rockyWall3
};
const rockyWall4: Environment =
{
    type: 'Wall',
    style: 'Caves',
    name: 'Rocky Wall 4',
    symbol: Icons.rockyWall4
};
const rockyWall5: Environment =
{
    type: 'Wall',
    style: 'Caves',
    name: 'Rocky Wall 5',
    symbol: Icons.rockyWall5
};
const rockyWall6: Environment =
{
    type: 'Wall',
    style: 'Caves',
    name: 'Rocky Wall 6',
    symbol: Icons.rockyWall6
};
const rockyWall7: Environment =
{
    type: 'Wall',
    style: 'Caves',
    name: 'Rocky Wall 7',
    symbol: Icons.rockyWall7
};
const rockyWall8: Environment =
{
    type: 'Wall',
    style: 'Caves',
    name: 'Rocky Wall 8',
    symbol: Icons.rockyWall8
};
const rockyWall9: Environment =
{
    type: 'Wall',
    style: 'Caves',
    name: 'Rocky Wall 9',
    symbol: Icons.rockyWall9
};
const rockyWall10: Environment =
{
    type: 'Wall',
    style: 'Caves',
    name: 'Rocky Wall 10',
    symbol: Icons.rockyWall10
};
const rockyWall11: Environment =
{
    type: 'Wall',
    style: 'Caves',
    name: 'Rocky Wall 11',
    symbol: Icons.rockyWall11
};
const rockyWall12: Environment =
{
    type: 'Wall',
    style: 'Caves',
    name: 'Rocky Wall 12',
    symbol: Icons.rockyWall12
};

export const rockyWalls: Environment[] = [
    rockyWall1, rockyWall2, rockyWall3, rockyWall4, rockyWall5, rockyWall6,
    rockyWall7, rockyWall8, rockyWall9, rockyWall10, rockyWall11, rockyWall12
];

const dungeonWall1: Environment = {
    type: 'Wall',
    style: 'Dungeon',
    name: 'Dungeon Wall 1',
    symbol: Icons.dungeonWall1
};
const dungeonWall2: Environment = {
    type: 'Wall',
    style: 'Dungeon',
    name: 'Dungeon Wall 2',
    symbol: Icons.dungeonWall2
};
const dungeonWall3: Environment = {
    type: 'Wall',
    style: 'Dungeon',
    name: 'Dungeon Wall 3',
    symbol: Icons.dungeonWall3
};
const dungeonWall4: Environment = {
    type: 'Wall',
    style: 'Dungeon',
    name: 'Dungeon Wall 4',
    symbol: Icons.dungeonWall4
};
const dungeonWall5: Environment = {
    type: 'Wall',
    style: 'Dungeon',
    name: 'Dungeon Wall 5',
    symbol: Icons.dungeonWall5
};
const dungeonWall6: Environment = {
    type: 'Wall',
    style: 'Dungeon',
    name: 'Dungeon Wall 6',
    symbol: Icons.dungeonWall6
};
const dungeonWall7: Environment = {
    type: 'Wall',
    style: 'Dungeon',
    name: 'Dungeon Wall 7',
    symbol: Icons.dungeonWall7
};
const dungeonWall8: Environment = {
    type: 'Wall',
    style: 'Dungeon',
    name: 'Dungeon Wall 8',
    symbol: Icons.dungeonWall8
};
const dungeonWall9: Environment = {
    type: 'Wall',
    style: 'Dungeon',
    name: 'Dungeon Wall 9',
    symbol: Icons.dungeonWall9
};
const dungeonWall10: Environment = {
    type: 'Wall',
    style: 'Dungeon',
    name: 'Dungeon Wall 10',
    symbol: Icons.dungeonWall10
};
const dungeonWall11: Environment = {
    type: 'Wall',
    style: 'Dungeon',
    name: 'Dungeon Wall 11',
    symbol: Icons.dungeonWall11
};
const dungeonWall12: Environment = {
    type: 'Wall',
    name: 'Dungeon Wall 2',
    symbol: Icons.dungeonWall12
};

export const dungeonWalls = [
    dungeonWall1, dungeonWall2, dungeonWall3, dungeonWall4, dungeonWall5, dungeonWall6,
    dungeonWall7, dungeonWall8, dungeonWall9, dungeonWall10, dungeonWall11, dungeonWall12
];

export const brokenDwall1: Environment = {
    type: 'Wall',
    name: 'brokenDWall_1',
    symbol: Icons.brokenDwall1
};

export const brokenDwall2: Environment = {
    type: 'Wall',
    name: 'brokenDWall_2',
    symbol: Icons.brokenDwall2
};

export const brokenDwalls: Environment[] = [
    brokenDwall1, brokenDwall2
];

const dungeonTorch1: Environment = {
    type: 'Wall',
    name: 'Dungeon Torch 1',
    symbol: Icons.dungeonTorch1
};
const dungeonTorch2: Environment = {
    type: 'Wall',
    name: 'Dungeon Torch 2',
    symbol: Icons.dungeonTorch2
};
const dungeonTorch3: Environment = {
    type: 'Wall',
    name: 'Dungeon Torch 3',
    symbol: Icons.dungeonTorch3
};
const dungeonTorch4: Environment = {
    type: 'Wall',
    name: 'Dungeon Torch 4',
    symbol: Icons.dungeonTorch4
};

export const dungeonTorches = [
    dungeonTorch1, dungeonTorch2, dungeonTorch3, dungeonTorch4
]

const library1: Environment = {
    type: 'Wall',
    name: 'Library1',
    symbol: Icons.library1
};
const library2: Environment = {
    type: 'Wall',
    name: 'Library2',
    symbol: Icons.library2
};
const library3: Environment = {
    type: 'Wall',
    name: 'Library3',
    symbol: Icons.library3
};
const library4: Environment = {
    type: 'Wall',
    name: 'Library4',
    symbol: Icons.library4
};
const library5: Environment = {
    type: 'Wall',
    name: 'Library5',
    symbol: Icons.library5
};
const library6: Environment = {
    type: 'Wall',
    name: 'Library6',
    symbol: Icons.library6
};
const library7: Environment = {
    type: 'Wall',
    name: 'Library7',
    symbol: Icons.library7
};
const library8: Environment = {
    type: 'Wall',
    name: 'Library8',
    symbol: Icons.library8
};
const library9: Environment = {
    type: 'Wall',
    name: 'Library9',
    symbol: Icons.library9
};
const library10: Environment = {
    type: 'Wall',
    name: 'Library10',
    symbol: Icons.library10
};
const library11: Environment = {
    type: 'Wall',
    name: 'Library11',
    symbol: Icons.library11
};
const library12: Environment = {
    type: 'Wall',
    name: 'Library12',
    symbol: Icons.library12
};
const library13: Environment = {
    type: 'Wall',
    name: 'Library13',
    symbol: Icons.library13
};
const library14: Environment = {
    type: 'Wall',
    name: 'Library14',
    symbol: Icons.library14
};
const library15: Environment = {
    type: 'Wall',
    name: 'Library15',
    symbol: Icons.library15
};
const library16: Environment = {
   type: 'Wall',
   name: 'Library16',
   symbol: Icons.library16
};

export const allLibraryWalls: Environment[] = [
    library1, library2, library3, library4, library5, library6, library7, library8,
    library9, library10, library11, library12, library13, library14, library15, library16
];

const weaponShack1: Environment = {
    type: 'Wall',
    name: 'WeaponShack1',
    symbol: Icons.weaponShack1
};
const weaponShack2: Environment = {
    type: 'Wall',
    name: 'WeaponShack2',
    symbol: Icons.weaponShack2
};
const weaponShack3: Environment = {
    type: 'Wall',
    name: 'WeaponShack3',
    symbol: Icons.weaponShack3
};
const weaponShack4: Environment = {
    type: 'Wall',
    name: 'WeaponShack4',
    symbol: Icons.weaponShack4
};

export const allWeaponShacks: Environment[] = [
    weaponShack1, weaponShack2, weaponShack3, weaponShack4
];

export const box: Environment =
{
   type: 'Object',
   name: 'Box',
   symbol: Icons.boxImg
};

export const fire: Environment =
{
    type: 'Object',
    name: 'Fire',
    symbol: Icons.fireImg
};

export const fountain: Environment =
{
    type: 'Object',
    name: 'Fountain',
    symbol: Icons.fountainImg
};

export const teleport: Environment =
{
    type: 'Teleporter',
    name: 'Teleport',
    coords: { x: 0, y: 0 },
    symbol: Icons.tpImg
};

// export const mapTeleport: Environment =
// {
//     type: 'Teleporter',
//     name: 'Map teleport',
//     symbol: Icons.mapTpImg,
// };

export const sign: Environment = {
    type: 'Object',
    name: 'Help sign',
    content: '',
    symbol: Icons.sign
};

export const bag: Environment =
{
    id: '',
    type: 'Object',
    name: 'Bag',
    symbol: Icons.bagImg,
    content: []
};

const caveCopper1: Node =
{
    id: '',
    type: 'Node',
    resourceType: 'Ore',
    mineral: 'Copper',
    biome: 'Rocky',
    name: 'Copper Node 1',
    symbol: Icons.caveCopper1,
    toughness: 1,
    maxHp: 2,
    hp: 2,
    drops: [ { item: Material.CopperOre, chance: 90, quantity: 1 } ]
};
const caveCopper2: Node =
{
    id: '',
    type: 'Node',
    resourceType: 'Ore',
    mineral: 'Copper',
    biome: 'Rocky',
    name: 'Copper Node 2',
    symbol: Icons.caveCopper2,
    toughness: 1,
    maxHp: 2,
    hp: 2,
    drops: [ { item: Material.CopperOre, chance: 90, quantity: 1 } ]
};
const caveCopper3: Node =
{
    id: '',
    type: 'Node',
    resourceType: 'Ore',
    mineral: 'Copper',
    biome: 'Rocky',
    name: 'Copper Node 3',
    symbol: Icons.caveCopper3,
    toughness: 1,
    maxHp: 2,
    hp: 2,
    drops: [ { item: Material.CopperOre, chance: 65, quantity: 2 } ]
};
const caveCopper4: Node =
{
    id: '',
    type: 'Node',
    resourceType: 'Ore',
    mineral: 'Copper',
    biome: 'Rocky',
    name: 'Copper Node 4',
    symbol: Icons.caveCopper4,
    toughness: 1,
    maxHp: 2,
    hp: 2,
    drops: [ { item: Material.CopperOre, chance: 90, quantity: 1 } ]
};
const caveCopper5: Node =
{
    id: '',
    type: 'Node',
    resourceType: 'Ore',
    mineral: 'Copper',
    biome: 'Rocky',
    name: 'Copper Node 5',
    symbol: Icons.caveCopper5,
    toughness: 1,
    maxHp: 2,
    hp: 2,
    drops: [ { item: Material.CopperOre, chance: 50, quantity: 3 } ]
};

export const caveCopper: Node[] = [ caveCopper1, caveCopper2, caveCopper3, caveCopper4, caveCopper5 ];

const dungeonCopper1: Node =
{
    id: '',
    type: 'Node',
    resourceType: 'Ore',
    mineral: 'Copper',
    biome: 'Dungeon',
    name: 'Dungeon Copper Node 1',
    symbol: Icons.dungeonCopper1,
    toughness: 1,
    maxHp: 2,
    hp: 2,
    drops: [ { item: Material.CopperOre, chance: 90, quantity: 1 } ]
};
const dungeonCopper2: Node =
{
    id: '',
    type: 'Node',
    resourceType: 'Ore',
    mineral: 'Copper',
    biome: 'Dungeon',
    name: 'Dungeon Copper Node 2',
    symbol: Icons.dungeonCopper2,
    toughness: 1,
    maxHp: 2,
    hp: 2,
    drops: [ { item: Material.CopperOre, chance: 90, quantity: 1 } ]
};

export const dungeonCopper: Node[] = [ dungeonCopper1, dungeonCopper2 ];

const caveSilver1: Node =
{
    id: '',
    type: 'Node',
    resourceType: 'Ore',
    mineral: 'Silver',
    biome: 'Rocky',
    name: 'Silver Node 1',
    symbol: Icons.caveSilver1,
    toughness: 1,
    maxHp: 3,
    hp: 3,
    drops: [ { item: Material.SilverOre, chance: 90, quantity: 1 } ]
};
const caveSilver2: Node =
{
    id: '',
    type: 'Node',
    resourceType: 'Ore',
    mineral: 'Silver',
    biome: 'Rocky',
    name: 'Silver Node 2',
    symbol: Icons.caveSilver2,
    toughness: 1,
    maxHp: 3,
    hp: 3,
    drops: [ { item: Material.SilverOre, chance: 85, quantity: 1 } ]
};
const caveSilver3: Node =
{
    id: '',
    type: 'Node',
    resourceType: 'Ore',
    mineral: 'Silver',
    biome: 'Rocky',
    name: 'Silver Node 3',
    symbol: Icons.caveSilver3,
    toughness: 1,
    maxHp: 3,
    hp: 3,
    drops: [ { item: Material.SilverOre, chance: 65, quantity: 2 } ]
};
const caveSilver4: Node =
{
    id: '',
    type: 'Node',
    resourceType: 'Ore',
    mineral: 'Silver',
    biome: 'Rocky',
    name: 'Silver Node 4',
    symbol: Icons.caveSilver4,
    toughness: 1,
    maxHp: 3,
    hp: 3,
    drops: [ { item: Material.SilverOre, chance: 90, quantity: 1 } ]
};
const caveSilver5: Node =
{
    id: '',
    type: 'Node',
    resourceType: 'Ore',
    mineral: 'Silver',
    biome: 'Rocky',
    name: 'Silver Node 5',
    symbol: Icons.caveSilver5,
    toughness: 1,
    maxHp: 3,
    hp: 3,
    drops: [ { item: Material.SilverOre, chance: 85, quantity: 1 } ]
};

export const caveSilver: Node[] = [ caveSilver1, caveSilver2, caveSilver3, caveSilver4, caveSilver5 ];

const forestTree1: Node =
{
    id: '',
    type: 'Node',
    resourceType: 'Wood',
    mineral: 'Forest Wood',
    biome: 'Forest',
    name: 'Forest tree 1',
    symbol: '',
    symbols: [ Icons.fTree1_top, Icons.fTree1_bot, "fTree1_stomp" ] ,
    toughness: 1,
    maxHp: 2,
    hp: 2,
    drops: [ { item: Material.wood1, chance: 100, quantity: 1 } ]
};
const forestTree1_stomp: Environment = {
    type: 'Wall',
    name: 'fTree1_stomp',
    symbol: Icons.fTree1_stomp
};

const forestTree2: Node =
{
    id: '',
    type: 'Node',
    resourceType: 'Wood',
    mineral: 'Forest Wood',
    biome: 'Forest',
    name: 'Forest tree 2',
    symbol: '',
    symbols: [ Icons.fTree2_top, Icons.fTree2_bot, "fTree2_stomp" ] ,
    toughness: 1,
    maxHp: 2,
    hp: 2,
    drops: [ { item: Material.wood1, chance: 100, quantity: 1 } ]
};
const forestTree2_stomp: Environment = {
    type: 'Wall',
    name: 'fTree2_stomp',
    symbol: Icons.fTree2_stomp
};

export const allTreeStomps: Environment[] = [
    forestTree1_stomp, forestTree2_stomp
]

export const allForestTrees: Node[] = [ forestTree1, forestTree2 ];

const bigCaveSilver1: Node =
{
    id: '',
    type: 'Node',
    resourceType: 'Ore',
    mineral: '',
    biome: 'Rocky',
    name: 'Big cave silver 1',
    symbols: [Icons.bigCaveSilver1, Icons.bigCaveSilver2, Icons.bigCaveSilver3, Icons.bigCaveSilver4],
    symbol: '',
    toughness: 1,
    maxHp: 2,
    hp: 2,
    drops: [ { item: Material.SilverOre, chance: 90, quantity: 7 } ]
};

const bigCaveCopper1: Node =
{
    id: '',
    type: 'Node',
    resourceType: 'Ore',
    mineral: '',
    biome: 'Rocky',
    name: 'Big cave copper 1',
    symbols: [Icons.bigCaveSilver1, Icons.bigCaveSilver2, Icons.bigCaveSilver3, Icons.bigCaveSilver4],
    symbol: '',
    toughness: 1,
    maxHp: 2,
    hp: 2,
    drops: [ { item: Material.SilverOre, chance: 90, quantity: 7 } ]
};

export const allBigSilverNodes: Node[] = [  bigCaveSilver1 ];

export const allBigCopperNodes: Node[] = [ bigCaveCopper1 ];

export const allTiles:  Environment[] =
[
    voidTile,
    basicWalls, torchedWall,
    cavesF1,
    dungeonF1, dungeonF2, dungeonF3, dungeonF4, dungeonF5,
    rockyWall1, rockyWall2, rockyWall3
];

export const allObjects:  Environment[] =
[
    box,
    fire,
    fountain,
    teleport,
    sign
];

export const allTeleporters: Environment[] =
[
    dungeonTp, dDoor1_left, dDoor1_right, dDoor2_left, dDoor2_right, transparentWall
];

export const allNodes: Node[] =
[
    caveSilver1, caveSilver2, caveSilver3, caveSilver4, caveSilver5,
    caveCopper1, caveCopper2, caveCopper3, caveCopper4, caveCopper5
];